import request from '@/utils/request.js'
const querystring = require('querystring')

// 口语点评状态统计数量
export function fetchStatusCount(payload) {
    return request.get('/hcp/teacherSpace/oralReview/statusStatistics')
}

export function fetchReviewDetail(payload) {
    return request.get('/hcp/teacherSpace/oralReview/getOralReviewDetail/' + payload)
}

// 打回录音
export function updateBackReview(payload) {
    return request.post('/hcp/teacherSpace/oralReview/teacherBackRecording', querystring.stringify(payload), {
        headers: { 'content-type': 'application/x-www-form-urlencoded' }
    })
}

// 保存点评
export function updateReviewContent(payload) {
    return request.post('/hcp/teacherSpace/oralReview/saveReview', payload)
}

export function submitReviewContent(payload) {
    return request.post('/hcp/teacherSpace/oralReview/teacherReview', payload)
}

export function putUpdateOralRemark(payload) {
    return request.put('/hcp/teacherSpace/speakCourse', payload)
}
//口语点评-教师回复评价
export function teacherReplyComment(payload) {
    return request.post("/hcp/teacherSpace/oralReview/teacherReply", payload)

}

// 获取口语点评老师
export function fetchCommentTeachers (payload) {
  return request.get('/hcp/teacherSpace/oralReview/getOralReviewTeacherList', payload)
}

// 分配
export function requestDistribute (payload) {
    return request.post(`/hcp/teacherSpace/oralReview/distributorAssign?${querystring.stringify(payload)}`)
  }

export function updateMeetingNumber(payload) {
  return request.post("/hcp/teacherSpace/speakCourse/updateMeetingNumber", payload);
}


// WEBPACK FOOTER //
// ./src/services/comment.js